import { attach, createEvent, createStore } from 'effector';

export interface Job {
  completed: boolean;
}

interface JobsState {
  enitites: Record<string, Job>;
}

const initialJobsState: JobsState = {
  enitites: {},
};

const $jobs = createStore(initialJobsState);

export const addJobEvent = createEvent<string>();

export const completeJobEvent = createEvent<string>();

$jobs.on(addJobEvent, (state, jobId) => {
  return {
    ...state,
    enitites: {
      ...state.enitites,
      [jobId]: {
        completed: false,
      },
    },
  };
});

$jobs.on(completeJobEvent, (state, jobId) => {
  return {
    ...state,
    enitites: {
      ...state.enitites,
      [jobId]: {
        completed: true,
      },
    },
  };
});

export const getJobFx = attach({
  source: [$jobs],
  effect: ([jobs]: [JobsState], jobId: string) => {
    return jobs.enitites[jobId];
  },
});
